//IndexDB para la Web

export const SimpleIDB = {
    myDBName: "Voolks",
    myStoreName: "Field",
    dbVersion: 2,
    dbPromise: null as Promise<IDBDatabase> | null,

    getDB(): Promise<IDBDatabase> {
        if (this.dbPromise) {
            return this.dbPromise;
        }

        this.dbPromise = new Promise((resolve, reject) => {
            if (typeof indexedDB === "undefined") {
                return reject(new Error("IndexedDB is not supported"));
            }

            const request = indexedDB.open(this.myDBName, this.dbVersion);

            request.onupgradeneeded = () => {
                const db = request.result;
                if (!db.objectStoreNames.contains(this.myStoreName)) {
                    db.createObjectStore(this.myStoreName);
                }
            };

            request.onsuccess = () => {
                const db = request.result;

                if (!db.objectStoreNames.contains(this.myStoreName)) {
                    db.close();
                    this.dbPromise = null;
                    return reject(new Error(`Object store '${this.myStoreName}' missing after open`));
                }

                db.onversionchange = () => {
                    db.close();
                    this.dbPromise = null;
                };

                db.onerror = (e) => {
                    console.error("IndexedDB error:", e);
                };

                resolve(db);
            };

            request.onerror = () => {
                this.dbPromise = null;
                reject(request.error);
            };

            request.onblocked = () => {
                console.warn("IndexedDB upgrade blocked by another connection");
            };
        });

        return this.dbPromise;
    },

    async initialize() {
        try {
            const db = await this.getDB();
            if (
                typeof window !== "undefined" &&
                window.localStorage &&
                window.localStorage.length > 0 &&
                window.localStorage["v3-migrateToIndexDB"] !== "1"
            ) {
                const tx = db.transaction(this.myStoreName, "readwrite");
                const st = tx.objectStore(this.myStoreName);
                for (const key of Object.keys(window.localStorage)) {
                    st.put(window.localStorage[key], key);
                }
                window.localStorage.setItem("v3-migrateToIndexDB", "1");
            }
        } catch (e) {
            console.error("SimpleIDB.initialize error:", e);
        }
        return this;
    },

    async getString(key: string): Promise<any> {
        const db = await this.getDB();
        return new Promise((resolve, reject) => {
            const tx = db.transaction(this.myStoreName, "readonly");
            const st = tx.objectStore(this.myStoreName);
            const req = st.get(key);
            req.onsuccess = () => {
                resolve(req.result !== undefined ? req.result : null);
            };
            req.onerror = () => {
                reject(req.error);
            };
        });
    },

    async setString(key: string, value: any): Promise<null> {
        return this.set(key, value);
    },

    async set(key: string, value: any): Promise<null> {
        const db = await this.getDB();
        return new Promise((resolve, reject) => {
            const tx = db.transaction(this.myStoreName, "readwrite");
            const st = tx.objectStore(this.myStoreName);
            const req = st.put(value, key);
            req.onsuccess = () => {
                resolve(null);
            };
            req.onerror = (e) => {
                console.error("SimpleIDB.set error:", e, req.error);
                reject(req.error);
            };
        });
    },

    async delete(key: string): Promise<null> {
        const db = await this.getDB();
        return new Promise((resolve, reject) => {
            const tx = db.transaction(this.myStoreName, "readwrite");
            const st = tx.objectStore(this.myStoreName);
            const req = st.delete(key);
            req.onsuccess = () => {
                resolve(null);
            };
            req.onerror = () => {
                reject(req.error);
            };
        });
    },

    async clearAll(): Promise<null> {
        const db = await this.getDB();
        return new Promise((resolve, reject) => {
            const tx = db.transaction(this.myStoreName, "readwrite");
            const st = tx.objectStore(this.myStoreName);
            const req = st.clear();
            req.onsuccess = () => {
                resolve(null);
            };
            req.onerror = () => {
                reject(req.error);
            };
        });
    },
};